/**
 * Verbatim prototype copy for the category view (spec B §1.2), as pure
 * helpers so the view and its tests share one source.
 */

/**
 * "Everyone can view · Editors and admins can edit" — built from the shown
 * category's `access_summary` (#871), i.e. who can ACTUALLY view and edit it,
 * resolved by the server from the access rules and role defaults.
 *
 * Deliberate change from the prototype, which printed the TOP-level
 * category's stored labels: those labels never controlled access, and a
 * subcategory can have its own rules, so the line now describes the category
 * or subcategory on screen.
 */
export { accessLine } from '../access/wikiAccessRules';

/** "Owner: Marcus Webb" ('' when the owner name is unknown). */
export function ownerLine(category) {
    const name = category && category.owner_name;
    return name ? `Owner: ${name}` : '';
}

export const QUOTE_EXACT_NOTE = 'Answers quote these pages word for word';

/** "Ask Sales" — the parent's name in a subcategory view. */
export function askLabel(topCategory) {
    return `Ask ${(topCategory && topCategory.name) || 'the Wiki'}`;
}

/** Section label above the page list (rendered uppercase by `.wk-t-label`). */
export function pagesLabel(isSub, topCategory) {
    return isSub ? 'Pages' : `Pages in ${(topCategory && topCategory.name) || ''} (not in a subcategory)`;
}

export const SUBCATEGORIES_LABEL = 'Subcategories';

export const EMPTY_TITLE = 'No pages here yet';
export const EMPTY_BODY = "Add the first page. Once it's published, Ask the Wiki can answer from it.";

export const NOT_FOUND_TITLE = "This category isn't available";
export const NOT_FOUND_BODY = "It may have been archived or moved, or you don't have access to it.";
